import * as $ from 'jquery';
export const showMoreCategories = () => {
    const $showMoreBtn = $('.show-more-categories-js');
    if(!$showMoreBtn) {
        return;
    }
    $showMoreBtn.on('click', function () {
        const $hiddenItems = $('.hidden-categories-wrapper-js');
        const $icon = $(this).find('.pseudo-icon');

        if ($icon.hasClass('opened')) {
            $hiddenItems.slideUp();
        } else {
            $hiddenItems.slideDown();
        }

        $icon.toggleClass('opened');

        $(this)
            .find('.button-text')
            .text($icon.hasClass('opened') ? 'Show Less' : 'Show More');
    });

    const $expandCategories = $('.expand-categories-js');
    if(!$expandCategories) {
        return;
    }
    $expandCategories.on('click', function () {
        const $wrapper = $('.categories-wrapper-js');

        $(this).toggleClass('expanded');
        $(this).find('.expand-categories').toggleClass('expanded');

        if ($(this).hasClass('expanded')) {
            $wrapper.slideDown();
        } else {
            $wrapper.slideUp();
        }
    });
}